var _circle, _g, _circle2, _circle3, _circle4, _circle5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyDesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 131,
  height: 131,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 65.5,
  cy: 65.756,
  r: 65,
  fill: "#E6F1FE"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-design_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.975 17a48.803 48.803 0 0 0-19.057 3.85 49.07 49.07 0 0 0-15.576 10.494 49.126 49.126 0 0 0-10.508 15.578c-2.462 5.822-4.045 12.293-3.849 19.141C17.708 91.276 36.3 115 65.532 115c3.987 0 7.116-.851 9.406-2.556 2.29-1.704 3.544-4.229 3.899-6.768.71-5.079-1.457-10.403-4.2-14.518-1.692-2.542-1.86-4.17-1.594-5.195.265-1.025 1.08-1.91 2.7-2.697 3.245-1.572 9.237-1.884 13.681-.772l.08.012.092.016c3.594.642 9.542 2.107 15.132.489 2.796-.808 5.522-2.524 7.385-5.428 1.864-2.904 2.856-6.84 2.856-12.039 0-6.331-1.37-12.758-3.85-18.622a49.035 49.035 0 0 0-10.495-15.58 49.042 49.042 0 0 0-15.57-10.493 48.908 48.908 0 0 0-19.079-3.848ZM54.511 30.284a7.422 7.422 0 0 1 5.248 12.673 7.423 7.423 0 1 1-5.248-12.672Zm22.944 0a7.422 7.422 0 0 1 5.248 12.673 7.42 7.42 0 0 1-10.496 0 7.427 7.427 0 0 1-2.175-5.25 7.424 7.424 0 0 1 7.423-7.423ZM36.29 45.131a7.423 7.423 0 1 1 0 14.848 7.423 7.423 0 0 1 0-14.848Zm59.388 0a7.424 7.424 0 1 1-5.248 12.673 7.427 7.427 0 0 1 5.248-12.673Z",
  fill: "#fff"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 37.5,
  r: 8.5,
  fill: "#B2D9AC"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 37.5,
  r: 8.5,
  fill: "#90C0F4"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 52.5,
  r: 8.5,
  fill: "#EEACB1"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 52.5,
  r: 8.5,
  fill: "#FFE4AC"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-design_svg__a",
  x: 3.969,
  y: 7.001,
  width: 124,
  height: 123.999,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_309_9567"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_309_9567",
  result: "effect2_dropShadow_309_9567"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_309_9567",
  result: "shape"
})))));
export { SvgEmptyDesign as Component };